// Supabase client (read-only realtime channels for FE). Only initialised when
// both VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are configured — otherwise
// the app falls back to polling /seatmap/state via useSeatmapState.

import { type SupabaseClient, createClient } from '@supabase/supabase-js';
import { env } from './env.ts';

let _client: SupabaseClient | null | undefined;

export function getSupabase(): SupabaseClient | null {
  if (_client !== undefined) return _client;
  const url = env.VITE_SUPABASE_URL;
  const key = env.VITE_SUPABASE_ANON_KEY;
  if (url && key && !url.includes('YOUR_PROJECT') && !key.startsWith('eyJ...')) {
    _client = createClient(url, key, { auth: { persistSession: false } });
  } else {
    _client = null;
  }
  return _client;
}

export const realtimeAvailable = (): boolean => getSupabase() !== null;
